import React from 'react';
import IconCircle from './IconCircle';
import PillButton from './PillButton';

function EmptyState({ icon, title, description, actionLabel, onAction, className = '' }) {
  return (
    <div className={`sgc-empty-state ${className}`}>
      <IconCircle icon={icon} tone="surface" size={56} />
      <p className="sgc-empty-state__title">{title}</p>
      {description && <p className="sgc-empty-state__description">{description}</p>}
      {actionLabel && onAction && (
        <PillButton variant="secondary" onClick={onAction}>{actionLabel}</PillButton>
      )}
    </div>
  );
}

export default EmptyState;
